const actions = {
  CREATE_TAG: 'CREATE_TAG',
  CREATE_TAG_ENDED: 'CREATE_TAG_ENDED',
  UPDATE_TAG: 'UPDATE_TAG',
  UPDATE_TAG_ENDED: 'UPDATE_TAG_ENDED',
  DELETE_TAGS: 'DELETE_TAGS',
  DELETE_TAGS_ENDED: 'DELETE_TAGS_ENDED',
  SEARCH_TAGS: 'SEARCH_TAGS',
  SEARCH_TAGS_ENDED: 'SEARCH_TAGS_ENDED',
  SEARCH_TAG_MEMBER_LIST_BATCH_ROW: 'SEARCH_TAG_MEMBER_LIST_BATCH_ROW',
  SEARCH_TAG_MEMBER_LIST_BATCH_ROW_ENDED: 'SEARCH_TAG_MEMBER_LIST_BATCH_ROW_ENDED',
  SEARCH_INVALID_TAG_MEMBER_LIST_BATCH_ROW_ENDED: 'SEARCH_INVALID_TAG_MEMBER_LIST_BATCH_ROW_ENDED',
  SEARCH_INVALID_TAG_MEMBER_LIST_BATCH_ROW: 'SEARCH_INVALID_TAG_MEMBER_LIST_BATCH_ROW',
  ADD_MEMBER_LIST_TO_TAG_MEMBER_LIST_ENDED: 'ADD_MEMBER_LIST_TO_TAG_MEMBER_LIST_ENDED',
  ADD_MEMBER_LIST_TO_TAG_MEMBER_LIST: 'ADD_MEMBER_LIST_TO_TAG_MEMBER_LIST',
  DELETE_MEMBERS_FROM_MEMBER_LIST_ENDED: 'DELETE_MEMBERS_FROM_MEMBER_LIST_ENDED',
  DELETE_MEMBERS_FROM_MEMBER_LIST: 'DELETE_MEMBERS_FROM_MEMBER_LIST',
  DELETE_TAG_MEMBER_LIST_BATCH_ROWS_ENDED: 'DELETE_TAG_MEMBER_LIST_BATCH_ROWS_ENDED',
  DELETE_TAG_MEMBER_LIST_BATCH_ROWS: 'DELETE_TAG_MEMBER_LIST_BATCH_ROWS',
  ADD_MEMBER_TO_TAG_MEMBER_LIST_ENDED: 'ADD_MEMBER_TO_TAG_MEMBER_LIST_ENDED',
  ADD_MEMBER_TO_TAG_MEMBER_LIST: 'ADD_MEMBER_TO_TAG_MEMBER_LIST',
};

export default actions;
